import React, { Component } from 'react'; // eslint-disable-line
import { Upload, Icon, message } from 'antd';
import firebase from "firebase";
import { deleteImageFromFirebase } from "../../services/firebase/storage";
import './ImageUploader.less';

class ImageUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isImageUploading: false,
    };
  }

  updateUploadFile(downloadURL, thumbnailName, oldThumbnailName, onImageUpload) {
    (oldThumbnailName && oldThumbnailName.length > 0) && deleteImageFromFirebase(oldThumbnailName);
    onImageUpload(downloadURL, thumbnailName);
    this.setState({ isImageUploading: false })
  }

  handleUpload(file, uniqueId) {
    const self = this;

    this.setState({
      isImageUploading: true,
    });

    const reader = new FileReader();
    const oldThumbnailName = this.props.thumbnailName || '';
    const type = file.name.split('.');

    reader.onloadend = function () {
      const thumbnailName = `${file.name}-${uniqueId}`;
      const data = new Blob([file], { type: `image/${type[1]}` });
      const storageRef = firebase.storage().ref();
      const uploadTask = storageRef.child(`images/${thumbnailName}`).put(data);

      uploadTask.on('state_changed',
        function(snapshot){
          let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          self.setState({ progressUpload: progress });
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED:
              // console.log('Upload is paused');
              break;
            case firebase.storage.TaskState.RUNNING:
              // console.log('Upload is running');
              break;
            default:
              break;
          }
        },
        function(error) {
          console.error('onloadend error', error);
          switch (error.code) {
            case 'storage/unauthorized':
              message.error('User doesn\'t have permission to access the object');
              break;

            default:
              message.error('Unknown error occurred, inspect error.serverResponse');
              break;
          }
        },
        function() {
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            console.log('File available at', downloadURL);

            const uploadAction = self.props.newElement ? self.props.onImageUpload : self.props.uploadItemAction;
            self.updateUploadFile(downloadURL, thumbnailName, oldThumbnailName, uploadAction )
          });
        }
      );
    };

    reader.onerror = function (e) {
      console.log("Failed file read: " + e.toString());
    };

    reader.readAsArrayBuffer(file);
  }

	getUploadProps() {
    const uniqueId = new Date().getTime();
    const { onImageUpload } = this.props;

    return {
			name: 'file',
			beforeUpload: (file) => {
				const imagesMimeTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/PNG'];
				const supportedMimeType = imagesMimeTypes.includes(file.type);
        const validSize = file.size / 1024 / 1024 < 5;

				if (!supportedMimeType) {
					message.error(`Sorry, but your file with mimeType ${file.type} is not supported`);
				}

				if (!validSize) {
					message.error('Image must be less than 5 MB!');
				}

        if (supportedMimeType && validSize) {
          onImageUpload && this.handleUpload(file, uniqueId);
        }

				// return supportedMimeType && validSize;
			},
      disabled: this.state.isImageUploading,
      onChange: (info) => {
        if (info.file.status === 'done') {
          this.setState({
						isImageUploading: false
          })
        }
        if (info.file.status === 'uploading') {
          this.setState({
            isImageUploading: true
          });
        }
        if (info.file.status === 'error') {
          this.setState({
            isImageUploading: false
          })
          // message.error(`${info.file.name} file upload failed.`)
        }
      }
    }
  }

  render() {
    const { imageUrl, isImageDataSent } = this.props;
		const uploadButton = (
			<div>
				<Icon type={this.state.isImageUploading ? 'loading' : 'plus'} />
				<div className="ant-upload-text">{this.props.uploadText || 'Upload'}</div>
			</div>
    );

    return (
      <div className={`upload-image-wr ${isImageDataSent ? '' : 'waiting'}`}>
        <Upload
          {...this.getUploadProps()}
          className={this.props.className ? this.props.className : 'base-uploader'}
          listType="picture-card"
          showUploadList={false}
        >
          {imageUrl ? <img src={imageUrl} alt="avatar" /> : uploadButton}
        </Upload>
      </div>
    );
  }

}

export default ImageUploader;



// WEBPACK FOOTER //
// ./src/components/Items/ImageUploader.js